
import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import { CreditCard } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { useCollectionForm } from '../context/CollectionFormContext';
import { UseFormReturn } from 'react-hook-form';

interface PaymentMethodSelectorProps {
  form: UseFormReturn<any>;
  isAuthRequest: boolean;
}

export const PaymentMethodSelector = ({ form, isAuthRequest }: PaymentMethodSelectorProps) => {
  const { loading, paymentMethods } = useCollectionForm();
  
  if (paymentMethods.length === 0) {
    return (
      <div className="rounded-md bg-muted p-3 text-sm">
        <p className="text-muted-foreground">У курьера нет сохраненных платежных методов</p>
      </div>
    );
  }
  
  return (
    <FormField
      control={form.control}
      name="paymentMethodId"
      render={({ field }) => (
        <FormItem>
          <FormLabel>
            Платежный метод
            {!isAuthRequest && (
              <Badge variant="destructive" className="ml-2">Обязательно</Badge>
            )}
          </FormLabel>
          <FormControl>
            <Select 
              disabled={loading}
              onValueChange={field.onChange}
              value={field.value}
            >
              <SelectTrigger>
                <SelectValue placeholder="Выберите платежный метод" />
              </SelectTrigger>
              <SelectContent>
                {paymentMethods.map((method) => (
                  <SelectItem key={method.id} value={method.id} className="py-2">
                    <div className="flex items-center gap-2">
                      <CreditCard className="h-4 w-4" />
                      <div className="flex flex-col">
                        <span className="font-medium">
                          {method.card_type || 'Карта'} *{method.card_last4}
                        </span>
                        {method.card_expiry_month && method.card_expiry_year && (
                          <span className="text-xs text-muted-foreground">
                            {method.card_expiry_month}/{method.card_expiry_year}
                            {method.source && (
                              <Badge variant="outline" className="ml-2 px-1.5 py-0 text-xs">
                                {method.source === 'courier' ? 'Основная' : 'Подписка'}
                              </Badge>
                            )}
                          </span>
                        )}
                      </div>
                    </div>
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </FormControl>
          <FormMessage />
          {isAuthRequest && (
            <FormDescription>
              Для запроса авторизации выбор платежного метода необязателен
            </FormDescription>
          )}
        </FormItem>
      )}
    />
  );
};
